import ReportBrandImageryEditHeaderLevel2 from './reportBrandImageryEditHeaderLevel2'
export default ReportBrandImageryEditHeaderLevel2
